
import React from "react";
import PageTop from "../../ui/page-top";
import ProductList from "../../components/all-products";
import useFetchCategories from "../../lib/hooks/use-fetch-categories";
import useFetchProducts from "../../lib/hooks/use-fetch-products";
import { getCurrentUser } from "../../lib/auth_base/localstorage";

export default  function Page() {
  const {products,loading} = useFetchProducts({limit:100,offset:0,mode:"all"}); 
  const {categories} = useFetchCategories(); 
  const user = getCurrentUser();
  return (
    <React.Fragment>
      <PageTop
        is_logged={user ? true : false}
        page={{ title: "Products", url: "/products", bg_color: "sky" }}
      />
      <div className="page-body">
        <div className="page-vertical-pad">
          <ProductList
            is_admin={user ? true:false}
            products={products}
            categories={categories}
            is_logged={user ? true : false}
            user={user}
            loading={loading}
          />
        </div>
      </div>
    </React.Fragment>
  );
}
